
export class CompanyInfo {
  CompanyId: number
  CompanyCode: string
  CompanyName: string
  CompanyType: string
  CompanyTypeName: string
  CompanyContactName: string
  CompanyLink: string
  CompanyIndustry: string
  CompanyIndustryDisplayName: string
  CompanyAbbreviation: string
  CompanyCustomerType: string
  CompanyCustomerTypeDisplayName: string
  CompanyGroupCode: string
  CompanyGroupName: string
  CompanyGroupTypeCode: string
  CompanyLegalEntityType: string
  CompanyLegalEntityTypeName: string
  CompanyDisplayReportFlag: string
  CompanyDescription: string
  CompanyCreateByPOPFlag: string
  CompanyIsMigrateFlag: string
  CompanyCountryDialCode: string
  CompanyPhone: string
  CompanyEmail: string
  CompanyFax: string
  CompanyPrefix: string
  CompanyCreateDate: string
  CompanyCreateBy: string
  CompanyCreateByDisplay: string
  CompanyUpdateDate: string
  CompanyUpdateBy: string
  CompanyUpdateByDisplay: string
  countConpany: number
  count: number
  rowOFFSet: number
  rowFetch: number
  CompanyFlagActive: string
  CompanyFlagDelete: string
  itemTotal: number
}
